/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const TratamentoSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['*']
    filtro.addOrder('ordem', 'asc')
  return filtro
}


export const  getTratamentoSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  return filtro
}

